export const createContestsRequests = (client) => ({
    listContests: async (params) => {
        const { data, meta, links } = await client.api.get("contests", {
            params: params,
        });
        return { data, meta, links };
    },
    findContest: async (params) => {
        const { data } = await client.api.get(`contests/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createContest: async (payload) => {
        const { data } = await client.api.create("contests", payload);
        return { data };
    },
    updateContest: async (payload) => {
        const { data } = await client.api.update("contests", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map